export default __webpack_public_path__ + "static/media/testimonials-bg.5460757c.png";